import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApplicationClientCommonModule } from '@sdbn/common';
import { TileButtonComponent } from './component/tile-button.component';
import { CommonTranslationModule } from '@sdbn/common';
import { MatRippleModule } from '@angular/material/core';


@NgModule({
  declarations: [
    TileButtonComponent
  ],
  imports: [
    CommonModule,

    ApplicationClientCommonModule,
    CommonTranslationModule,
    MatRippleModule
  ],
  exports: [
    TileButtonComponent
  ]
})
export class TileButtonModule {

 }
